import { Column, TABLE_ACTION, defaultColActionDef, defaultColDef, formatter } from '@qrios/frontend-library';

import { predefinedColumns } from '../../../../../common/table/columns';
import { withNullFallback } from '../../../../../../constants/helpers/utils';
// eslint-disable-next-line max-len
import voiceSessionCloseReasonToString from '../../../../../../constants/voiceSessionCloseReasonsToString';

const ACTIONS = [TABLE_ACTION.INFO];

export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'id',
    headerName: 'Session Id',
    flex: 1,
    minWidth: 150
  },
  predefinedColumns.date({}),
  {
    ...defaultColDef,
    field: 'appId',
    headerName: 'App Id',
    flex: 1.5
  },
  {
    ...defaultColDef,
    field: 'customerMsisdn',
    headerName: 'Phone number',
    flex: 1.5
  },
  {
    ...defaultColDef,
    field: 'duration',
    headerName: 'Duration',
    flex: 0.7,
    valueFormatter: formatter.timeFormatter
  },
  {
    ...defaultColDef,
    field: 'sessionCloseReason',
    headerName: 'Session close reason',
    flex: 2.25,
    valueFormatter: value => {
      if (value.value === null || value.value === undefined) {
        return withNullFallback(value.value);
      }
      return voiceSessionCloseReasonToString(value.value as string);
    }
  },
  {
    ...defaultColDef,
    field: 'sessionTag',
    headerName: 'Session Tag',
    flex: 1.2,
    valueFormatter: value => withNullFallback(value.value)
  },
  predefinedColumns.cost({}),
  defaultColActionDef(ACTIONS)
];
